module.exports = __webpack_public_path__ + "images/404.1790041056745.png";